import { TrainingLength } from '../models/TrainingLength'

export const isValidTrainingLength = (value?: string | null): boolean =>
  Object.values(TrainingLength).includes(value as TrainingLength)
